/**
 * To execute commands
 */

import {
  downloadExcelByDD,
  saveByDD,
  deleteByDD,
  sqlByDD,
  post
} from 'y4/Y4Api';
import y, {
  formatByNamedArgs,
  encrypt,
  removeUi,
  decrypt,
  getMenuPath
} from 'y4/Utils';
import s from 'y4/layouts/content/Y4ApiForScript';
import { modal } from 'y4/components/modal/ModalContainer';
import _ from 'lodash';
import RT from 'y4/RT';

/**
 * Call execute and show message after execute
 * @param {*} command string
 * @param {*} success fucntion call after command success
 */
function run({ command, success, ...rest }) {
  if (command) {
    const promise = execute({
      command: command,
      ...rest
    });

    promise.then(rt => {
      if (rt.isNotOk()) {
        y.toastError(rt.message);
      } else {
        if (success) {
          success(rt.tag);
        } else {
          if (rt.message) {
            y.toastSuccess(rt.message);
          }
        }
      }
    });

    return promise;
  } else {
    y.toastError('The botton has no command', { theme: 'colored' });
  }
}

/**
 *
 * @param {*} param0
 * @returns
 */
async function execute({ command, ...rest }) {
  if (command == 'DownloadExcelByDataDefinition') {
    return await downloadExcelByDataDefinition(rest);
  } else if (command == 'NavigateTo') {
    return await navigateTo(rest);
  } else if (command == 'Refresh') {
    return await refresh(rest);
  } else if (command == 'SaveByDataDefinition') {
    return await saveByDataDefinition(rest);
  } else if (command == 'SqlByDataDefinition') {
    return await sqlByDataDefinition(rest);
  } else if (command == 'Confirm') {
    return await confirm(rest);
  } else if (command == 'DeleteByDataDefinition') {
    return await deleteByDataDefinition(rest);
  } else if (command == 'PostToServlet') {
    return await postToServlet(rest);
  } else if (command == 'RunScript') {
    return await runScript(rest);
  } else {
    return new RT({ id: 69999, message: `No support command:${command} ` });
  }
}

/**
 *
 * @param {*} scd successCommand
 * @param {*} rest
 * @returns
 */
function generateSuccessCommand(scd, rest) {
  return {
    form: rest.form,
    panel: rest.panel,
    dataCode: rest.dataCode,
    navigate: rest.navigate,
    filter: rest.filter,
    rows: rest.rows,
    queries: rest.queries,

    command: scd.command,
    params: scd.params,
    successCommand: scd.successCommand
  };
}

/**
 *
 * @param {*} rest
 * @returns
 */
async function downloadExcelByDataDefinition(rest) {
  const params = rest.params;
  if (params && params.javascript) {
    const f = Function('y', 'source', rest.params.javascript);
    const fr = f(y, {
      form: rest.form,
      panel: rest.panel,
      params
    });
    if (fr) {
      const rt_f = new RT(fr);
      if (rt_f.isNotOk()) return rt_f;
    }
  }

  let index = parseInt(y.gpv(rest, 'params.index'), 10) || 0;
  let count = parseInt(y.gpv(rest, 'params.count'), 10) || -1;
  if (index < 0) index = 0;
  if (count < -1) count = -1;

  return await downloadExcelByDD({
    code: rest.dataCode,
    index: index,
    count: count,
    ...rest.filter
  });
}

/**
 *
 * @param {*} rest
 * @returns
 */
async function saveByDataDefinition(rest) {
  //remove "Ui" at field end
  const data = removeUi(rest.rows[0]);
  delete rest.rows;
  //Split fields
  if (!rest.params) rest.params = {};
  const { dataCode, params } = rest;
  params.data = data;

  //Run per javascript
  if (params.javascript) {
    const f = Function('y', 'source', params.javascript);
    const fr = f(y, {
      form: rest.form,
      panel: rest.panel,
      data
    });
    if (fr) {
      const rt_f = new RT(fr);
      if (rt_f.isNotOk()) {
        if (rt_f.isCancel()) {
          return rt_f;
        } else {
          return rt_f;
        }
      } else {
        if (rt_f.message) {
          y.toastError(rt_f.message);
        }
      }
    }
  }

  var last_params = y.mergeByPredicate(p => {
    return p != 'javascript';
  }, params);

  //Call backend api save new/old package
  const rt = await saveByDD(dataCode, last_params);
  afterCommand(rt, rest);
  return rt;
}

/**
 *
 * @param {*} rest
 * @returns
 */
async function sqlByDataDefinition(rest) {
  //remove "Ui" at field end
  const data = removeUi(rest.rows[0]);
  delete rest.rows;
  //Split fields
  const { dataCode, params } = rest;
  params.data = data;

  //Run per javascript
  if (params.javascript) {
    const f = Function('y', 'source', params.javascript);
    const fr = f(y, {
      form: rest.form,
      panel: rest.panel,
      data
    });
    if (fr) {
      const rt_f = new RT(fr);
      if (rt_f.isNotOk()) {
        if (rt_f.isCancel()) {
          return rt_f;
        } else {
          return rt_f;
        }
      } else {
        if (rt_f.message) {
          y.toastError(rt_f.message);
        }
      }
    }
  }

  var last_params = y.mergeByPredicate(p => {
    return p != 'javascript';
  }, params);

  //Call backend api save new/old package
  const rt = await sqlByDD(dataCode, last_params);
  afterCommand(rt, rest);
  return rt;
}

function afterCommand(rt, rest) {
  if (rt.isOk()) {
    if (!rt.message && rest.successMessage) {
      rt.message = rest.successMessage;
    } else if (rest.successCommand) {
      run(generateSuccessCommand(rest.successCommand, rest));
    }
    //Success command or message from rt.data
    var scfd = _.get(rt.data, 'successCommand');
    if (scfd) {
      run(generateSuccessCommand(scfd, rest));
    } else {
      var sm = _.get(rt.data, 'successMessage');
      if (!rt.message && sm) {
        rt.message = sm;
      }
    }
  }
}

/**
 *
 * @param {*} rest
 * @returns
 */
async function deleteByDataDefinition(rest) {
  //remove "Ui" at field end
  const data = removeUi(rest.rows[0]);

  //Split fields
  if (!rest.params) rest.params = {};
  const { dataCode, params } = rest;
  params.data = data;

  //Call backend api save new/old package
  const rt = await deleteByDD(dataCode, params);
  afterCommand(rt, rest);
  return rt;
}

/**
 *
 * @param {*} rest
 * @returns
 */
async function postToServlet(rest) {
  const { params } = rest;
  const rows = _.isArray(rest.rows)
    ? rest.rows.map(r => {
        return removeUi(r);
      })
    : null;

  const ps = y.ifThen(
    params.bodyType == 'FormData',
    () => {
      var fd = new FormData();
      if (rows) fd.append('rows', JSON.stringify(rows));
      if (params.params) {
        for (const p in params.params) {
          const v = params.params[p];
          if (_.isNumber(v) || _.isString(v) || _.isDate(v) || _.isBoolean(v)) {
            fd.append(p, v);
          } else {
            fd.append(p, JSON.stringify(v));
          }
        }
      }
      return fd;
    },
    () => {
      return {
        rows: rows,
        ...params.params
      };
    }
  );

  const qs = {
    ...rest.queries,
    ...params.queries
  };

  if (params.javascript) {
    const f = Function('y', 'source', params.javascript);
    const fr = f(y, {
      form: rest.form,
      panel: rest.panel,
      queries: qs,
      body: ps
    });
    if (fr) {
      const rt_f = new RT(fr);
      if (rt_f.isNotOk()) {
        if (rt_f.isCancel()) {
          return rt_f;
        } else {
          return rt_f;
        }
      } else {
        if (rt_f.message) {
          y.toastError(rt_f.message);
        }
      }
    }
  }

  const conf = params.timeout ? { timeout: params.timeout } : null;

  //Call backend api save new/old package
  const rt = await post(params.servlet, params.command, ps, qs, conf);
  afterCommand(rt, rest);
  return rt;
}

/**
 *
 * @param {*} rest
 * @returns
 */
async function runScript(rest) {
  const { params } = rest;
  const f = Function('y', 's', 'source', params.javascript);
  const fr = f(y, s, rest);
  const rt = new RT(fr);
  afterCommand(rt, rest);
  return rt;
}

/**
 *
 * @param {*} rest
 * @returns
 */
async function navigateTo(rest) {
  if (!rest.params) {
    return new RT({
      id: 1,
      message: 'No params field at command NavigateTo'
    });
  }

  //Get data in rows
  const f_row = _.head(rest.rows);
  const row = _.mapKeys(f_row, (v, k) => {
    if (_.endsWith(k, 'Ui')) {
      return k.slice(0, -2);
    } else {
      return k;
    }
  });

  let original_url = null; //using to navigate
  let other = null; //using to navigate

  // params is string or object
  if (_.isString(rest.params)) {
    original_url = rest.params;
    other = {};
  } else {
    //split url and params
    const { url, ...url_rest } = rest.params;
    original_url = url;
    other = url_rest;
  }

  original_url = getMenuPath(rest?.form?.corp, original_url);

  //queries and row
  const union_up_row = unionRowAndQueries(rest.queries, row);
  //Format url by querirs and row
  const formated_url = formatByNamedArgs(original_url, union_up_row);

  other.rows = [union_up_row];

  //Navigate to url
  const en_data = encodeURIComponent(encrypt(JSON.stringify(other)));
  const flag = formated_url.includes('?') ? '&' : '?';
  const to = { url: `${formated_url}${flag}other=${en_data}` };

  //Run script, script can to change url
  const { params } = rest;
  if (params.javascript) {
    const f = Function('y', 'source', params.javascript);
    const fr = f(y, {
      form: rest.form,
      panel: rest.panel,
      to
    });
    if (fr) {
      const rt_f = new RT(fr);
      if (rt_f.isNotOk()) {
        if (rt_f.isCancel()) {
          return rt_f;
        } else {
          return rt_f;
        }
      } else {
        if (rt_f.message) {
          y.toastError(rt_f.message);
        }
      }
    }
  }

  if (_.get(rest, 'params.type') == 'window') {
    const root =
      window.location.href.split('/')[0] + process.env.REACT_APP_PUBLIC_URL;
    const redirect_url = root + to.url;
    window.location.replace(redirect_url);
  } else {
    rest.navigate(to.url);
  }

  return new RT();
}

/**
 * Union queries and row
 * @param {*} queries url queries
 * @param {*} row current data
 * @returns return union data
 */
function unionRowAndQueries(queries, row) {
  //Use current queries of page format url
  let qs = {};
  if (queries) {
    const { other, ...rest } = queries;
    qs = rest;
    if (other) {
      const o = JSON.parse(decrypt(decodeURIComponent(other)));
      const r = o.rows[0];
      qs = { ...qs, ...r };
    }
  }
  return { ...qs, ...row }; //row override qs
}

/**
 *
 * @param {*} rest
 * @returns
 */
async function refresh(rest) {
  const url = y.getValue(() => {
    if (rest.params) {
      //Get data
      const row = _.head(rest.rows);
      //Format to url by data
      return formatByNamedArgs(rest.params, row);
    } else {
      const h = window.location.href;
      const s = h.indexOf('/y4/');
      return encodeURIComponent(h.substring(s));
    }
  });

  //Navigate to url
  rest.navigate(`/y4/content/blank?url=${url}`);
  return new RT();
}

/**
 * Confirm by modal dialog
 * @param {*} rest
 * @returns
 */
function confirm(rest) {
  const row = rest.rows[0];
  modal.dialog(
    formatByNamedArgs(rest.params.title, row),
    formatByNamedArgs(rest.params.caption, row),
    formatByNamedArgs(rest.params.message, row),
    [
      {
        text: rest.params.okText,
        check: () => {
          if (rest.params.javascript) {
            const f = Function('y', 'source', rest.params.javascript);
            return f(y, {
              form: rest.form,
              panel: rest.panel
            });
          }
        },
        click: () => {
          run(generateSuccessCommand(rest.successCommand, rest));
        }
      },
      {
        text: rest.params.cancelText,
        variant: 'secondary'
      }
    ]
  );
  return new RT();
}

export { execute, run };
